import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {
        search: {injectedAdsConfig},
        template,
        request: {environmentName},
    } = state

    const injectedAdEnvironment: string = injectedAdsConfig.environmentKeys[environmentName] as string

    return {
        templating: template,
        injectedAdEnvironment,
    }
}

export default connect(mapStateToProps)
